﻿package org.zq.pixelset.processing

import org.zq.pixelset.model.DecodedImage
import kotlin.math.min
import kotlin.math.sqrt

object ImageDecodeGuard {
    /** 最大像素数（约 3500×3500） */
    const val MAX_PIXELS = 12_000_000L

    /** 单边最大边长 */
    const val MAX_DIMENSION = 6000

    fun normalize(decoded: DecodedImage): Pair<DecodedImage, String?> {
        val pixels = decoded.width.toLong() * decoded.height
        if (pixels <= MAX_PIXELS &&
            decoded.width <= MAX_DIMENSION &&
            decoded.height <= MAX_DIMENSION
        ) {
            return decoded to null
        }
        val scale = min(
            MAX_DIMENSION.toFloat() / decoded.width,
            min(
                MAX_DIMENSION.toFloat() / decoded.height,
                sqrt(MAX_PIXELS.toFloat() / pixels),
            ),
        ).coerceAtMost(1f)
        val w = (decoded.width * scale).toInt().coerceAtLeast(1)
        val h = (decoded.height * scale).toInt().coerceAtLeast(1)
        val scaled = ImageResize.scaleBilinear(decoded, w, h)
        val mp = (pixels / 1_000_000f)
        val warning = "原图约 ${formatMp(mp)}MP（${decoded.width}×${decoded.height}），已自动缩至 ${w}×${h} 以节省内存"
        return scaled to warning
    }

    private fun formatMp(mp: Float): String {
        val v = (mp * 10).toInt()
        return "${v / 10}.${v % 10}"
    }
}
